import { AfterViewChecked, AfterViewInit, Component, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MasonryGridItem } from './masonry-grid-item';
import { AppComponent } from '../../../app.component';

@Component({
  selector: 'anon-masonry-grid',
  templateUrl: './masonry-grid.component.html',
  styleUrls: ['./masonry-grid.component.scss']
})
export class MasonryGridComponent implements AfterViewChecked, AfterViewInit {
  @Input()
  items?: MasonryGridItem[];

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public href(link?: string) {
    if (link) {
      const tempElement = this.document.createElement('a');
      tempElement.href = link;
      tempElement.target = '_blank';
      tempElement.style.display = 'none';

      tempElement.click();
    }
  }

  /*
  * Resize the items when all the images inside the masonry grid
  * finish loading. This will ensure that all the content inside our
  * masonry items is visible.
  *
  * @uses Document
  * @uses resizeMasonryItem
  */
  ngAfterViewInit() {
    if (!AppComponent.isBrowser) return;

    const allImages = this.document.images;
    Promise.all(
      Array.from(allImages)
        .filter(img => !img.complete)
        .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))
    ).then(() => {
      console.log('all images have loaded');
      this.resizeAllMasonryItems();
    });
  }

  ngAfterViewChecked() {
    this.resizeAllMasonryItems();
  }

  /* Resize all the grid items on resize events */
  onResize(event: UIEvent) {
    this.resizeAllMasonryItems();
  }

  resizeMasonryItem(item: any) {
    // get grid object, row-gap, and size of its implicit rows
    const grid = this.document.getElementsByClassName('masonry')[0];
    if (grid) {
      const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      const gridImagesAsContent = item.querySelector('img.masonry-content');

      /*
      * Spanning for any brick = S
      * Grids row-gap = G
      * Size of grid's implicitly create row-track = R
      * Height of item content = H
      * Net height of the item = H1 = H + G
      * Net height of the implicit row-track = T = G + R
      * S = H1 / T
      */
      const rowSpan = Math.ceil((item.querySelector('.masonry-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
      // set the spanning as calculated above (S)
      item.style.gridRowEnd = 'span ' + rowSpan;
      // Make imaged take all the available space in the cell/item
      if (gridImagesAsContent)
        item.querySelector('img.masonry-image').style.height = item.getBoundingClientRect().height + "px";
    }
  }

  /*
    * Apply spanning to all the masonry items
    * Loop through all the items and apply the spanning to them using
    * `resizeMasonryItem()` function
    * @uses resizeMasonryItem
    */
  resizeAllMasonryItems() {
    if (!AppComponent.isBrowser) return;

    const allItems = this.document.querySelectorAll('.masonry-item');
    /*
    * Loop through the above list and execute the spanning function to
    * each list-item (i.e. each masonry item)
    */
    for (let i = 0; i < allItems.length; i++) {
      this.resizeMasonryItem(allItems[i]);
    }

  }
}
